import React, {Component} from 'react';
import Swiper from 'react-id-swiper';
import Homeslider from './homeslider';
import Header from './Headers';
import Footer from '../footer';
import {inject, observer} from 'mobx-react';
import {Link} from "react-router-dom";
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import MediaPage from './mediapage';
import Testimonial from './Testimonial';
import NewsBlogs from './NewsBlogs';
import MobileLayout from './MobileLayout';
import ContactForm from './ContactForm';
import imagesPath from '../config/imagesPath';
import config from 'config'


@inject('store')
@observer
class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            screendata: [],
            title: '',
            isMobile: null
        }
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.ourMedia();
    }


    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        let currentHideNav = (window.innerWidth <= 767);
        if (currentHideNav !== this.state.isMobile) {
            this.setState({isMobile: currentHideNav});
        }
    }

    ourMedia() {
        fetch(`${config.REV_URL}/mediadetails`, {
            method: 'get'
        })
            .then(res => res.json())
            .then(response => {
                console.log('ree', response)
                this.setState({
                    screendata: response.result[0].mediaList,
                    title: response.result[0].title
                })
            }).catch((err) => {
            console.log(err)
        })
    }


    componentDidMount() {
        this.initializeReactGA()
        this.props.store.homeType(true)
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/homepage');
    }

    render() {

        const mediaScreen = {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            loop: true,
            slidesPerView: 4,
            spaceBetween: 15,
            autoplay: {
                delay: 10000,
            },
            breakpoints: {
                480: {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
            }
        }

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Smartest, Fastest Electric Vehicle Loans </title>
                    <meta name="title" content="Personal loan for Electric Vehicles"/>
                    <meta name="description"
                          content="Revfin offers Electric Vehicle loans to independent electric vehicle drivers."/>
                    <meta name="keywords" content="Electric Vehicle loan"/>

                </Helmet>
                <Header/>
                <section className="banner_text">
                    <Homeslider/>
                </section>

                {(this.state.isMobile) ? (<MobileLayout/>) : (<div>
                        <div className="container-old" data-aos="fade-up">
                            <section id="about" className="about">
                                <div className='container'>
                                    <div className="section-titles ">
                                        <h3 className="heading_tow">WHAT WE DO</h3>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-lg-9 col-md-9 pt-lg-0 content d-flex flex-column justify-content-center text-right"
                                            data-aos="fade-up" data-aos-delay="100">
                                            <h3 className='text-align'> Financing independent commercial EV
                                                drivers </h3>
                                            <p className="blue-color content-info">
                                                Revfin is a technology company. It's subsidiary company (Aristo
                                                Securities Private Limited, an NBFC) provides loans to independent
                                                drivers who buy and operate passenger or cargo electric vehicles for
                                                last mile connectivity. Partnerships with EV manufacturers and
                                                dealerships Pan-India to provide point of sale financing.
                                            </p>
                                        </div>
                                        <div className="col-lg-3 col-md-3  mb-15 padding-top-auto" data-aos="fade-right"
                                             data-aos-delay="100">
                                            <img src={imagesPath.img2} className="img-fluid imgborder-destop-view"
                                                 alt="Pictorial Representation of Business model"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="gray-bgcolor"></div>
                                <div className="blue-bgcolor"></div>
                            </section>
                        </div>
                        <div className="container-old" data-aos="fade-up">
                            <section id="about" className="about section-bg">
                                <div className='container'>
                                    <div className="row">
                                        <div
                                            className="col-lg-9 col-md-9 pt-4 pt-lg-0 content d-flex flex-column justify-content-center text-left order-md-2 "
                                            data-aos="fade-right" data-aos-delay="100">
                                            <h3 className='text-align'>Driver cum Owner (DCO) fleet vehicle
                                                operators</h3>
                                            <p className="blue-color content-info">
                                                Revfin is a technology company. It's subsidiary company (Aristo
                                                Securities Private Limited, an NBFC) provides loan or Lease to drivers
                                                who buy and operate passenger or cargo electric vehicles for last mile
                                                connectivity through E-commerce, Fleet operators & logistics
                                                company.</p>
                                        </div>
                                        <div className="col-lg-3 col-md-3 mb-15 padding-top-bike order-md-1 "
                                             data-aos="fade-up" data-aos-delay="100">
                                            <img src={imagesPath.img3} className="img-fluid imgborder-destop-view"
                                                 alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="gray-bgcolor"></div>
                                <div className="blue-bgcolor"></div>
                            </section>
                        </div>
                    </div>
                )}

                <section>
                    <div className='container'>
                        <div className="container" data-aos="fade-up">
                            <div className="section-titles">
                                <h3 className="heading_tow">HOW WE DO IT</h3>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-6 mb-6">
                                    <iframe height="538" src={imagesPath.video1} title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen style={{
                                        width: '100%'
                                    }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="container padding-bottom-partners" data-aos="fade-up">
                    <div className="section-titles">
                        <h3 className="heading_tow">OUR PARTNERS</h3>
                    </div>
                    <section className="slider_loan">
                        <div className="container" data-aos="zoom-in" data-aos-delay="100">
                            <div className="cara_slider newAdditon">
                                <Swiper {...mediaScreen} >
                                    {
                                        imagesPath.partnerLogo.map((res, index) => (
                                            <div className="swiper-slide" key={index}>
                                                <div className="slider_pannel" style={{
                                                    height: "240px",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}>
                                                    <div className="home-partner-logo" style={{width: '100%'}}>
                                                        <img src={res.img} alt=''/>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Swiper>
                            </div>
                        </div>
                    </section>
                    <div className="btnalign-center pt-3">
                        <Link to="/partner"><img src={imagesPath.img4} alt="more button" className="more-btn"/> </Link>
                    </div>
                </div>
                <Testimonial/>
                <NewsBlogs/>
                <div className="container">
                    <div className="section-titles">
                        <h3 className="heading_tow">REVFIN IN MEDIA</h3>
                    </div>
                    {
                        (this.state.screendata != '') ? <MediaPage screendata={this.state.screendata}/> : null
                    }
                </div>
                <ContactForm/>
                <Footer/>
            </div>
        )
    }
}


export default Home



// WEBPACK FOOTER //
// ./src/components/home.js